
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { singularityStore } from "@/store/store";
import { NavLink } from "./TopNavBuilder.vue";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    Icon
  }
})
export default class SideNavButton extends Vue {
  @Prop() link!: NavLink;

  openPanel(panelState: NavLink["panelState"]) {
    if (panelState?.leftPanel !== undefined) {
      singularityStore.setSingularityLeftPanel(panelState.leftPanel);
    }
    if (panelState?.rightPanel !== undefined) {
      singularityStore.setSingularityRightPanel(panelState.rightPanel);
    }
    if (panelState?.fullWidthPanel !== undefined) {
      singularityStore.setSingularityFullWidthPanel(panelState.fullWidthPanel);
    }
  }

  get isActive() {
    return (
      (this.link.panelState?.leftPanel &&
        singularityStore.singularityUiState.singularityLeftPanel ===
          this.link.panelState?.leftPanel) ||
      (this.link.panelState?.fullWidthPanel &&
        singularityStore.singularityUiState.singularityFullWidthPanel ===
          this.link.panelState?.fullWidthPanel) ||
      (this.link.panelState?.rightPanel &&
        singularityStore.singularityUiState.singularityRightPanel ===
          this.link.panelState?.rightPanel)
    );
  }

  handleClick() {
    if (this.link.action) {
      this.link.action();
    } else {
      this.openPanel(this.link.panelState);
      logEvent("FutureLayer Top Nav Click", {
        name: this.link.name
      });
    }
  }
}
